import React from 'react';
import { Grid, TextField, Typography } from '@mui/material';
import { Box } from '@mui/system';
import { ContactDetails } from '~/types';
import { BOOKING_CONTEXT } from '~/literals';
import CountrySelector from './CountrySelector';


interface TravelerContactDetailssProps {
  handleFieldChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  contactDetails: ContactDetails | undefined;
  errors: Record<any, string[]> | null;
  bookingContext: string;
}

const TravelerContactDetails = ({ handleFieldChange, contactDetails, bookingContext, errors: errorMessages }: TravelerContactDetailssProps) => {
  return (
    <Box style={{ padding: '16px', margin: '20px 0' }}>
      <Typography variant="h6" component="div" sx={{ margin: '0 0 20px' }}>
        Contact Details
      </Typography>
      <Typography variant="body2" sx={{ margin: '0 0 20px' }}>
        After booking with us, you'll receive a booking confirmation by email, sent to the contact details you provide below.
      </Typography>
      <Box>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={6}>
            <TextField
              type="email"
              label="Email"
              name="email"
              autoComplete="new-password"
              value={contactDetails?.email}
              fullWidth
              onChange={handleFieldChange}
              error={!!errorMessages && errorMessages?.email?.length > 0}
              helperText={
                errorMessages && errorMessages?.email?.length > 0
                  ? errorMessages?.email?.join("\n")
                  : null
              }
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <Grid container spacing={0}>
              <Grid item xs={4} sm={3}>
                <CountrySelector
                  showFlags
                  showCountryLabel
                  showCountryCodes
                  showPhoneCodes
                  handleFieldChange={(value) => {
                    const syntheticEvent: React.ChangeEvent<HTMLInputElement> = {
                      target: { name: "countryCode", value },
                    } as React.ChangeEvent<HTMLInputElement>;
                    handleFieldChange(syntheticEvent);
                  }}
                  label="Code*"
                  country={contactDetails?.phoneNumbers[0].countryCode || ""}
                  valueField="phone"
                  selectedDisplayField="phone"
                  errors={errorMessages?.countryCode || []}
                  autoCompleteStyles={{
                    "& div": {
                      paddingRight: "0 !important",
                      borderRadius: "20px 0 0 20px",
                    },
                  }}
                />
              </Grid>
              <Grid item xs={8} sm={9}>
                <TextField
                  type="number"
                  label="Mobile Number"
                  name="number"
                  autoComplete="new-password"
                  value={contactDetails?.phoneNumbers[0].number}
                  fullWidth
                  onChange={handleFieldChange}
                  error={!!errorMessages && errorMessages?.number?.length > 0}
                  helperText={
                    errorMessages && errorMessages?.number?.length > 0
                      ? errorMessages?.number?.join("\n")
                      : null
                  }
                  sx={{
                    "& div": {
                      borderRadius: "0 20px 20px 0",
                    },
                  }}
                />
              </Grid>
            </Grid>
          </Grid>

          {bookingContext !== BOOKING_CONTEXT.FLIGHT_ITINERARY && (
            <>
              <Grid item xs={12} sm={6}>
                <TextField
                  label="Address"
                  name="addressLines"
                  value={contactDetails?.addressLines?.length ? contactDetails?.addressLines[0] : ""}
                  fullWidth
                  autoComplete="new-password"
                  onChange={handleFieldChange}
                  error={!!errorMessages && errorMessages?.addressLines?.length > 0}
                  helperText={
                    errorMessages && errorMessages?.addressLines?.length > 0
                      ? errorMessages?.addressLines?.join("\n")
                      : null
                  }
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  label="Post Code"
                  name="postalCode"
                  value={contactDetails?.postalCode}
                  fullWidth
                  autoComplete="new-password"
                  onChange={handleFieldChange}
                  error={!!errorMessages && errorMessages?.postalCode?.length > 0}
                  helperText={
                    errorMessages && errorMessages?.postalCode?.length > 0
                      ? errorMessages?.postalCode?.join("\n")
                      : null
                  }
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  label="City"
                  name="city"
                  autoComplete="new-password"
                  value={contactDetails?.city?.friendlyName}
                  fullWidth
                  onChange={handleFieldChange}
                  error={!!errorMessages && errorMessages?.city?.length > 0}
                  helperText={
                    errorMessages && errorMessages?.city?.length > 0
                      ? errorMessages?.city?.join("\n")
                      : null
                  }
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <CountrySelector
                  showFlags
                  showCountryLabel
                  handleFieldChange={(value) => {
                    const syntheticEvent: React.ChangeEvent<HTMLInputElement> = {
                      target: { name: "country", value },
                    } as React.ChangeEvent<HTMLInputElement>;
                    handleFieldChange(syntheticEvent);
                  }}
                  label="Country*"
                  country={contactDetails?.country?.code || ""}
                  valueField="code"
                  selectedDisplayField="label"
                  errors={errorMessages?.country || []}
                />
              </Grid>
            </>
          )}
        </Grid>

      </Box>
    </Box>
  );
};

export default TravelerContactDetails;
